import { FC, useState } from "react";
import { FieldError, MUIIcon, Spinner } from "../../../../widgets";
import { useSendMobileOTPMutation, useVerifyOTPMutation } from "../services";

export interface IVerificationProps {
    children?: React.ReactNode
}

export const OtpVerification: FC<IVerificationProps> = ({
    children
}) => {
    const [otp, setOTP] = useState<string>('')
    const [requestedMobile, setRequestedMobile] = useState<string>('')
    const [requested, setRequested] = useState<boolean>(false)

    const [verified, setVerified] = useState<boolean>(false)
    const [mobile, setMobile] = useState<string>('')
    const [error, setError] = useState<string>('')

    const [sendOTP, { isLoading: sending }] = useSendMobileOTPMutation()
    const [verifyOTP, { isLoading: verifying }] = useVerifyOTPMutation()

    const handleBlur = () => {
        handleSendOTP();
    }

    const handleMobileChange = (mobile: string) => {
        setVerified(false)
        setRequested(false);
        setOTP('')

        setMobile(mobile)
    }

    const handleSendOTP = () => {
        if (!mobile) return;

        sendOTP({ identifier: mobile })
            .unwrap()
            .then(() => {
                setRequestedMobile(mobile)
                setVerified(false)
                setRequested(true)
            })
    }

    const handleVerifyOTP = () => {
        if (!mobile || !requested || !otp || requestedMobile !== mobile)
            return;

        verifyOTP({ identifier: mobile, otp })
            .unwrap()
            .then((result) => {
                setVerified(result.verified)
                if (!result.verified) {
                    setError('OTP entered is not correct.')
                }
            })
    }

    if (verified) {
        return <>{children}</>
    }

    return <>
        <div className="d-flex flex-row flex-wrap gap-2">
            <div className="flex-fill d-flex align-items-center gap-2">
                <input
                    className="form-control form-control-sm"
                    type="mobile"
                    value={mobile || ''}
                    readOnly={sending}
                    onBlur={handleBlur}
                    onChange={(e) => handleMobileChange(e.target.value)}
                />
                {(verified) && <>
                    <MUIIcon iconName="VerifiedOutlined" className=" text-primary" />
                </>}
            </div>
            {(!verified) && <>
                <div className="d-flex flex-row mw-300px align-items-center gap-2">
                    <div className="flex-fill">
                        <input
                            className="form-control form-control-sm fw-semibold"
                            disabled={!mobile}
                            type="text"
                            placeholder="Enter OTP"
                            value={otp || ''}
                            onBlur={handleVerifyOTP}
                            onChange={(e) => setOTP(e.target.value)}
                        />
                    </div>
                    <div className="d-flex flex-row gap-2">
                        <button
                            type="button"
                            disabled={!mobile || sending || !!otp}
                            onClick={() => handleSendOTP()}
                            className="btn btn-sm btn-primary py-1 fw-semibold">
                            <div className="d-flex align-items-center gap-2">
                                <label>Resend</label>
                                {(!sending) ? <>
                                    <MUIIcon iconName="SendOutlined" className="fs-7" />
                                </> : <>
                                    <Spinner show={true} />
                                </>}
                            </div>
                        </button>
                        <button
                            type="button"
                            disabled={!mobile || !requested || !otp}
                            onClick={() => handleVerifyOTP()}
                            className="btn btn-sm btn-primary py-1 fw-semibold">
                            <div className="d-flex align-items-center gap-2">
                                {(!verifying) ? <>
                                    <MUIIcon iconName="CheckOutlined" className="fs-7" />
                                </> : <>
                                    <Spinner show={true} />
                                </>}
                                <label>Verify</label>
                            </div>
                        </button>
                    </div>
                </div>
            </>}
        </div>
        <FieldError show={!!error} message={error} />
    </>
}
